<template>
    <div>
        <p class="little-label">功能授权：</p>
        <AuthChooseItem v-for='(item,index) in wh5eData' :key='index' :name='item.name' @click='click(item)'
            :selected='item.select' />
        <div class="line-dot"></div>
        <template v-if="curProduct">
            <p class="little-label">数据授权：</p>
            <Wh5eAuthChoose ref='choosen' :preClick='preClick' :authConfigData='authData' :isMonth='isOrderByMonth' />
            
            <div class="line-dot"></div>
        </template>
        <p style='padding-top: 0px;' class="little-label">已勾选：{{authNames}}</p>
    </div>
</template>

<script>
    import wh from '@/assets/js/wh.js'
    import Wh5eAuthChoose from './Wh5eAuthChoose.vue'
    export default {
        name: 'new-buy',
        components: {
            Wh5eAuthChoose
        },
        inject: ['changeMainPrice','changeDocTemplete', 'orderByMonth', 'orderByYear', 'orderByQuarter'],
        provide() {
            let self = this
            return {
                selectAuthItem(x) {
                    self.selectData = JSON.parse(JSON.stringify(x.filter(v => !v
                        .isChecked))) //isChecked为默认选中，目前默认选中的不计入产品ids
                },
                fatherType() {
                    return 'new'
                }
            }
        },
        props: {
            data: Array,
        },
        data: () => ({
            chooseData: [],
            selectData: [],
            deadLine: [{
                    name: '按年支付',
                    value: 1,
                    selected: true,
                    disable: false
                },
                {
                    name: '按季支付',
                    value: 2,
                    selected: false,
                    disable: true
                },
                {
                    name: '按月支付',
                    value: 0,
                    selected: false,
                    disable: true
                },

            ],
            wh5eData: [],
            authData: []
        }),
        computed: {
            hasMajor() {
                let flag = -1
                this.selectData.forEach(v => {
                    if (v.cmajor === 1 && v.productlink && (!v.productlink.includes('EUREX') && !v.productName
                            .includes('香港'))) {
                        flag = 1
                    } else if (v.cmajor === 0 && v.productlink && (!v.productlink.includes('EUREX') && !v
                            .productName.includes('香港'))) {
                        flag = 0
                    }
                })
                return flag
            },
            hasOgz() {
                let flag = -1
                this.selectData.forEach(v => {
                    if (v.cmajor === 1 && v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v.productName
                            .indexOf('香港') >= 0)) {
                        flag = 1
                    } else if (v.cmajor === 0 && v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v
                            .productName.indexOf('香港') >= 0)) {
                        flag = 0
                    }
                })
                return flag
            },
            hasOut() {
                let flag = false
                this.selectData.forEach(v => {
                    if (v.grouptype == 1 || v.grouptype == 2 || v.grouptype == 3 || v.grouptype == 4) {
                        flag = true
                    }
                })
                return flag
            },
            selectIds() {
                let ids = this.curProduct.name == '5C标准版' ? [this.curProduct.origin_id] : []
                return ids.concat(this.selectData.map(v => v.id)).join(',')
            },
            orderLimit() {
                let target = this.deadLine.find(v => v.selected)
                if (target) {
                    return target.value
                } else {
                    return -1
                }
            },
            isOrderByMonth() {
                return this.deadLine.find(v => v.value == 0).selected
            },
            isOrderByQuarter() {
                return this.deadLine.find(v => v.value == 2).selected
            },
            hasHistoryData () {
                return this.$refs.choosen.hasHistoryData
            },
            curProduct () {
                return this.wh5eData.find(v => v.select)
            },
            authNames () {
                var auth = [this.curProduct?.name]
                return auth.concat(this.selectData.map(v => v.name || v.productName)).join('+')
            }
        },
        watch: {
            data (val) {
                this.authData = [val[1]]
                let _5e = {
                    ...JSON.parse(JSON.stringify(val[1])),
                    id: wh.randomId(),
                    name: '5E基础版',
                    select: true
                },
                _5c = {
                    ...JSON.parse(JSON.stringify(val[1])),
                    id: wh.randomId(),
                    name: '5C标准版',
                    price: val[0].price,
                    origin_id: val[0].id,
                    select: false
                }
                this.wh5eData = [_5e, _5c]
            },
            curProduct: {
                handler (val) {
                    if (val) {
                        if (val.name == '5C标准版') {
                            this.changeMainPrice(val.price)
                            this.changeDocTemplete(128)
                        } else {
                            this.changeMainPrice(0)
                            this.changeDocTemplete(129)
                        }
                        setTimeout(() => {
                            this.$refs.choosen.cancelEach()
                        })
                    }
                },
                immediate: true
            }
        },
        mounted() {

        },
        methods: {
            click(item) {
                this.wh5eData.forEach((v, i) => {
                    if (item.id == v.id) {
                        this.$set(v, 'select', true)
                    } else {
                        this.$set(v, 'select', false)
                    }
                })
            },
            preClick() {
                if (this.orderLimit == -1 && this.canOrderByMonth) {
                    this.$market.alert({
                        content: '请选则支付方式'
                    })
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>

<style scoped>
    .little-label {
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
        padding: 0 0 4px;
        margin: 0;
    }

    .line-dot {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }

    .choose_item {
        float: left;
    }
</style>